module.exports = __webpack_public_path__ + "img/print_filled_24.1f1d687e.svg";